import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll on every route change. Without this, SPA navigation
// keeps the previous page's scroll position (e.g. footer links open the next
// page already scrolled to the bottom).
export default function ScrollToTop() {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        // if the URL targets an anchor, honor it instead of forcing top
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView();
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, search, hash]);

    return null;
}
